<template>
  <v-container>
    <v-row align="center" justify="center">
      <v-col cols="12" md="8" lg="7">
        <v-card>
          <v-card-title>
            Importar objetivos mensuales por agencia

            <v-btn text absolute right link small href="/files/AgenciaObjetivo.csv" target="_blank">
              <v-icon left>download</v-icon> CSV de ejemplo
            </v-btn>
          </v-card-title>



          <v-card-text>
            <caja-mensual-objetivo-combobox
                v-model="cajaMensualId"
                @loaded="onCajasLoaded"
                @error="onCajasError"
            />

            <file-upload-express
                v-if="cajaMensualId"
                @fileUploaded="onFileUploaded"
                auto-submit
            />



            <v-alert v-if="!cajaMensualId && cajasLoaded" dense type="warning">
              No hay cajas mensuales disponibles.
            </v-alert>

            <div v-if="!file" class="text-left mt-4">
              <h4 class="subtitle-1">Subir archivo .csv</h4>
              <h3 class="subtitle-2 primary--text mt-4">Campos del csv</h3>
              <ul>
                <li><b>Agencia</b></li>
                <li><b>Compra o Cartera</b></li>
                <li><b>Objetivos Independientes</b></li>
              </ul>
            </div>
          </v-card-text>

          <v-card-actions >
            <v-spacer></v-spacer>
            <v-btn text color="primary" :to="{name: 'AgenciaObjetivoDashboardAdminPage'}">
              Ver dashboard por agencia y objetivos cargados
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>

          <v-card-text v-if="loadingImport">
            <v-alert dense type="info">Importando objetivos.</v-alert>
            <v-progress-linear indeterminate />
          </v-card-text>

          <v-card-text v-if="result">
            <v-alert dense type="success">
              Procesados: {{ result.cantidadProcesada }} |
              Creados: {{ result.cantidadCreada }} |
              Actualizados: {{ result.cantidadActualizada }} |
              Errores: {{ result.errores.length }}
            </v-alert>

            <v-data-table
                v-if="result.errores.length"
                :headers="headers"
                :items="result.errores"
                dense
                class="mt-4"
            />
          </v-card-text>

          <v-card-text v-if="error">
            <v-alert dense type="error">{{ error }}</v-alert>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {FileUploadExpress} from '@dracul/media-frontend'
import AgenciaObjetivoProvider from "@/modules/cobrox/providers/AgenciaObjetivoProvider";
import CajaMensualObjetivoCombobox from "@/modules/cobrox/combobox/CajaMensualObjetivoCombobox/CajaMensualObjetivoCombobox";

export default {
  name: "AgenciaObjetivoImport",
  components: {CajaMensualObjetivoCombobox, FileUploadExpress},
  data() {
    return {
      cajaMensualId: null,
      file: null,
      result: null,
      error: null,
      cajasLoaded: false,
      loadingImport: false,
      headers: [
        {text: 'Fila', value: 'fila'},
        {text: 'Agencia', value: 'agencia'},
        {text: 'Compra/Cartera', value: 'compra'},
        {text: 'Error', value: 'error'},
      ]
    }
  },
  methods: {
    onCajasLoaded() {
      this.cajasLoaded = true
    },
    onCajasError(e) {
      this.error = e.message
      this.cajasLoaded = true
    },
    onFileUploaded(file) {
      this.file = file
      this.importar(file.id)
    },
    importar(fileId) {
      this.loadingImport = true
      this.result = null
      this.error = null
      AgenciaObjetivoProvider.importarObjetivosAgencia(this.cajaMensualId, fileId)
          .then(r => {
            this.result = r.data.importarObjetivosAgencia
          })
          .catch(e => {
            this.error = e.message
          })
          .finally(() => {
            this.loadingImport = false
          })
    }
  }
}
</script>
